module.exports = __webpack_public_path__ + "img/pic_app04.97cd8add.png";